import Cookie from "js-cookie";
import {
    SOCIAL_MEDIA,
    FACEBOOK_ACCESS_TOKEN_FLAG_COOKIE_NAME,
    TWITTER_TOKEN_FLAG_COOKIE_NAME,
    APPLE_AUTH_INFO_FLAG_COOKIE_NAME,
    BSSO_ACCESS_TOKEN_FLAG_COOKIE_NAME
} from "../../../common/constants/Constants";
import appConfig from "./appConfig";

const ACCESS_TOKENS_BY_SITE: {[s: string]: string} = {
    [SOCIAL_MEDIA.FACEBOOK]: FACEBOOK_ACCESS_TOKEN_FLAG_COOKIE_NAME,
    [SOCIAL_MEDIA.TWITTER]: TWITTER_TOKEN_FLAG_COOKIE_NAME,
    [SOCIAL_MEDIA.APPLE]: APPLE_AUTH_INFO_FLAG_COOKIE_NAME,
    [SOCIAL_MEDIA.TERMINAL]: BSSO_ACCESS_TOKEN_FLAG_COOKIE_NAME
};

class SocialSignIn {
    public _timers: {[s: string]: number};

    constructor() {
        this._timers = {};
    }

    login(socialSite: string, callback: () => void): void {
        const existingTimer = this._timers[socialSite];

        window.clearInterval(existingTimer);
        const child = openLoginWindow(socialSite);

        const timer = window.setInterval(() => {
            // [LC] 6/21/2016 I can't just check if the childWindow.closed property to stop the interval,
            // because the cookie set in child window is not synced to parent immediately in IE browsers (10, 11, Edge mode)
            // the interval will be removed by either user navigate away from this page or after user signed in
            if (hasAccessToken(socialSite)) {
                // [SC] 7/16/2019 I can't close the popup via the /api route on the server as done when on the same domain
                // so add an additional check here for if the social result redirect back to the front-end domain, which
                // then allows me to close the child
                try {
                    if (child) {
                        child.close();
                    }
                } catch (error) {
                    console.log("child isn't mine :(", error);
                }

                window.clearInterval(timer);
                callback();
            }
        }, 500);

        this._timers[socialSite] = timer;
    }

    cleanup(): void {
        const timerKeys = Object.keys(this._timers);

        for (let index = timerKeys.length - 1; index >= 0; index --) {
            const timerKey = timerKeys[index];

            window.clearInterval(this._timers[timerKey]);
        }
    }
}

function hasAccessToken(socialSite: string): boolean {
    return Boolean(Cookie.get(ACCESS_TOKENS_BY_SITE[socialSite]));
}

function openLoginWindow(socialSite: string): null | Window {
    switch (socialSite) {
        case SOCIAL_MEDIA.FACEBOOK:
        case SOCIAL_MEDIA.APPLE:
            return openPopUp(`/api/login/${ socialSite }-auth-redirect`, socialSite, "width=1000,height=680");
        case SOCIAL_MEDIA.TWITTER:
            return openPopUp(`/api/login/${ socialSite }-auth-redirect`, socialSite, "width=500,height=500");
        case SOCIAL_MEDIA.TERMINAL:
            return openPopUp("/api/login/bloomberg-auth-redirect", socialSite, "width=400,height=525,location=no");
        default:
            throw new Error(`Unknown social site: ${ socialSite }`);
    }
}

function openPopUp(path: string, site: string, options: string): null | Window {
    return window.open(`${ appConfig().registrationServiceUrl }${ path }`, site, options);
}

export default SocialSignIn;
